var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 107,
    viewBox: "0 0 136 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.011 56.9912H136C129.01 60.5767 126.803 67.7478 125.576 88.1287C124.718 102.66 120.426 106.434 120.426 106.434C117.237 106.434 114.049 85.4868 111.228 63.2187C112.332 59.4444 113.803 57.5573 116.011 56.9912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.303 106.245H100.314C103.87 106.245 106.323 95.866 107.794 82.6561C108.775 73.7866 109.756 67.3704 111.105 63.03C113.926 85.2981 117.114 106.245 120.303 106.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.105 63.03C109.634 67.1817 108.653 73.7866 107.794 82.6561C106.323 95.866 103.87 106.245 100.314 106.245C96.512 104.924 93.4462 82.6561 89.3993 48.6878C89.2767 47.5556 89.1541 46.612 89.0314 45.4797C92.0973 21.1358 95.2857 0 98.4742 0H99.5779C103.379 1.32099 106.445 23.5891 110.492 57.5573C110.737 59.2557 110.86 61.1429 111.105 63.03Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5887 0H98.4741C95.2857 0 91.9746 21.1358 89.0314 45.6684C86.2109 22.6455 82.8998 0 79.5887 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0315 45.6684C88.7862 48.1217 88.4183 50.575 88.173 53.2169C83.6356 91.3369 80.9377 105.302 77.7492 106.434C74.1929 106.434 70.7592 81.7125 67.9386 57.5573C67.9386 57.1799 67.816 56.8025 67.816 56.425C67.9386 55.2928 68.0612 54.3492 68.1839 53.2169C72.7213 14.9083 75.4192 1.13228 78.485 0H79.5887C82.8998 0 86.2109 22.6455 89.0315 45.6684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7492 106.245H57.76C61.1937 106.245 64.6275 82.6561 67.6933 56.2363C67.6933 56.6138 67.8159 56.9912 67.8159 57.3686C70.7591 81.7125 74.3155 106.245 77.7492 106.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8159 56.425C64.6274 82.8448 61.1937 106.434 57.8826 106.434C54.081 105.113 51.0152 82.8448 46.9683 48.8765C46.8457 47.7443 46.723 46.8007 46.6004 45.6684C49.5436 21.1358 52.732 0 55.9205 0H57.0242C60.8258 1.32099 63.769 23.0229 67.8159 56.425Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.035 0H55.9205C52.7321 0 49.5436 21.1358 46.4778 45.6684C43.6572 22.6455 40.3461 0 37.035 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4778 45.6684C46.2326 48.1217 45.8647 50.575 45.6194 53.2169C41.082 91.3369 38.3841 105.302 35.1956 106.434C31.6392 106.434 32.9882 105.49 30.7808 90.2046C28.5734 74.9189 26.8566 65.8607 24.5265 61.1429C24.8944 58.5009 25.1397 55.8589 25.5076 53.2169C30.1676 14.9083 32.8656 1.13228 35.9314 0H37.0351C40.3462 0 43.6573 22.6455 46.4778 45.6684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1955 106.245H15.2064C18.3948 106.245 21.5833 85.2981 24.6491 60.9541C26.8565 65.672 28.5734 74.7302 30.9034 90.0159C33.1108 105.302 31.6392 106.245 35.1955 106.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6492 60.9541C21.5834 85.2981 18.3949 106.245 15.2065 106.245C14.8386 105.49 12.6312 106.245 10.5464 87.3739C8.70694 70.0123 5.39585 59.067 0 56.9912H19.9892C21.9513 56.9912 23.3003 58.3122 24.6492 60.9541Z",
    fill: "#131313"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialize);
export default __webpack_public_path__ + "static/media/materialize.e80bdcad066cdeb025a0172dcb397c9d.svg";
export { ForwardRef as ReactComponent };